import { render, staticRenderFns } from "./hierarchy-dropdown-component.vue?vue&type=template&id=45c6d7b4&scoped=true"
import script from "./hierarchy-dropdown-component.ts?vue&type=script&lang=ts&external"
export * from "./hierarchy-dropdown-component.ts?vue&type=script&lang=ts&external"
import style0 from "./hierarchy-dropdown-component.scss?vue&type=style&index=0&id=45c6d7b4&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c6d7b4",
  null
  
)

export default component.exports